import { Structure, StructureType } from '@/lib/model';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import * as React from 'react';
import { Candidates } from './Candidates';
import { CandidatesModal } from './CandidatesModal';
import { Charts } from './Charts';
import { DemoVars } from './DemoVars';
import { Details } from './Details';
import './index.scss';
import { Tabs } from './Tabs';

export interface ResultsStructureProps {
  structure: Structure;
  isModalOpened: boolean;
  setIsModalOpened: (value: boolean) => void;
  structureType: StructureType;
}

export const ResultsStructure: React.FC<ResultsStructureProps> = ({
  structure,
  isModalOpened,
  setIsModalOpened,
  structureType,
}) => (
  <>
    <Details
      collegeName={structure.collegeName}
      fillColor={structure.fillColor}
      mapSettings={structure.mapSettings}
      onModalOpen={() => setIsModalOpened(true)}
      structureType={structureType}
    />
    <CandidatesModal
      fillColor={structure.fillColor}
      isOpened={isModalOpened}
      data={structure.candidates}
      onClose={() => setIsModalOpened(false)}
    />
    <Tabs options={['I candidati', 'Risultati 2018', 'In cifre']}>
      <TabPanelUnstyled value={0}>
        <div className="Results__content">
          <Candidates data={structure.candidates} />
        </div>
      </TabPanelUnstyled>
      <TabPanelUnstyled value={1}>
        <div className="Results__content">
          <Charts data={structure.prevElectionChart} />
        </div>
      </TabPanelUnstyled>
      <TabPanelUnstyled value={2}>
        <div className="Results__content">
          <DemoVars
            collegeName={structure.collegeName}
            fillColor={structure.fillColor}
            variables={structure.demographicVars}
            positionMessage={structure.demographicDesc}
          />
        </div>
      </TabPanelUnstyled>
    </Tabs>
  </>
);
